import React, { useEffect } from "react";
import { useTranslation } from "next-i18next";
import Cookies from "js-cookie";
import { useUI } from "@contexts/ui.context";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@components/ui/dialog";
import { useRouter } from "next/router";
import { useRegionQuery } from "@framework/common/get-region";
import RegionSelectorModalSkeleton from "@components/ui-old/loaders/region-selector-modal-loader";
import { IoLocationSharp } from "react-icons/io5";
import { setSiteCookie } from "@framework/utils/set-cookies";
const RegionSelectorModal: React.FC = () => {
  const {
    t
  } = useTranslation("common");
  const {
    setModalView,
    closeModal
  } = useUI();
  const router = useRouter();
  const {
    data: regions,
    isLoading,
    error
  } = useRegionQuery();
  const handleRegionSelect = (region: {
    pk: number;
    region: string;
  }) => {
    setSiteCookie("choosedKzRegionid", region.pk.toString());
    setSiteCookie("choosedKzRegion", region.region);
    closeModal();
    router.reload();
  };
  useEffect(() => {
    const choosedRegionId = Cookies.get("choosedKzRegionid");
    if (choosedRegionId) {
      closeModal();
    }
  }, [closeModal]);
  if (isLoading) return <RegionSelectorModalSkeleton />;
  if (error) return <p>{t("text-error")}</p>;
  return <Dialog open={setModalView} onOpenChange={isOpen => {
    if (!isOpen) {
      if (regions?.length) {
        handleRegionSelect(regions[0]);
      }
    }
  }} data-sentry-element="Dialog" data-sentry-component="RegionSelectorModal" data-sentry-source-file="region-selector-modal.tsx">
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="region-selector-modal.tsx">
        <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="region-selector-modal.tsx">
          <DialogTitle className="flex items-center space-x-2" data-sentry-element="DialogTitle" data-sentry-source-file="region-selector-modal.tsx">
            <IoLocationSharp className="text-xl" data-sentry-element="IoLocationSharp" data-sentry-source-file="region-selector-modal.tsx" />
            <span>{t("text-region-select")}</span>
          </DialogTitle>
          <DialogDescription className="text-left" data-sentry-element="DialogDescription" data-sentry-source-file="region-selector-modal.tsx">
            {t("text-region-select-info")}
          </DialogDescription>
        </DialogHeader>
        <ul className="mt-4 space-y-2">
          {regions?.map(region => <li key={region.pk}>
              <button onClick={() => handleRegionSelect(region)} className="
                  w-full px-4 py-2 text-left 
                  bg-neutral-100 hover:bg-neutral-900
                  text-neutral-900 hover:text-neutral-100
                  border border-neutral-500
                  rounded-xl shadow-md transition-colors
                  focus:outline-none
                ">
                {region.region}
              </button>
            </li>)}
        </ul>
      </DialogContent>
    </Dialog>;
};
export default RegionSelectorModal;